import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { API_BASE_URL } from "../config";

function UrineForm() {
  const [form, setForm] = useState({
    name: "",
    ageSex: "",
    doctor: "",
    date: "",
    quantity: "",
    color: "",
    appearance: "",
    ph: "",
    specificGravity: "",
    glucoseSugar: "",
    albuminProtein: "",
    ketone: "",
    bileSalts: "",
    bilePigment: "",
    urobilinogen: "",
    leukocyte: "",
    redBloodCell: "",
    epithelialCell: "",
    cast: "",
    bacteria: "",
    crystals: "",
  });

  const [reports, setReports] = useState([]);
  const [editId, setEditId] = useState(null);
  const [selectedReport, setSelectedReport] = useState(null);

  const fetchReports = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/urine-reports`);
      setReports(res.data);
    } catch (err) {
      console.error("Error fetching reports", err);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await axios.put(`${API_BASE_URL}/api/urine-reports/${editId}`, form);
        setEditId(null);
      } else {
        await axios.post(`${API_BASE_URL}/api/urine-reports`, form);
      }
      setForm({
        name: "",
        ageSex: "",
        doctor: "",
        date: "",
        quantity: "",
        color: "",
        appearance: "",
        ph: "",
        specificGravity: "",
        glucoseSugar: "",
        albuminProtein: "",
        ketone: "",
        bileSalts: "",
        bilePigment: "",
        urobilinogen: "",
        leukocyte: "",
        redBloodCell: "",
        epithelialCell: "",
        cast: "",
        bacteria: "",
        crystals: "",
      });
      fetchReports();
    } catch (err) {
      console.error("Error saving report", err);
    }
  };

  const handleEdit = async (id) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/urine-reports/${id}`);
      setForm(res.data);
      setEditId(id);
    } catch (err) {
      console.error("Error loading report", err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this report?")) {
      try {
        await axios.delete(`${API_BASE_URL}/api/urine-reports/${id}`);
        fetchReports();
      } catch (err) {
        console.error("Error deleting report", err);
      }
    }
  };

  const handleView = async (id) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/urine-reports/${id}`);
      setSelectedReport(res.data);
    } catch (err) {
      console.error("Error viewing report", err);
    }
  };

  return (
    <>
      <div className="container my-3">
        <h3>URINE EXAMINATION FORM</h3>

        <form onSubmit={handleSubmit}>
          <div className="row mb-2">
            <div className="col-md-6">
              <label>Pt. Name:</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={form.name}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label>Age/Sex:</label>
              <input
                type="text"
                className="form-control"
                name="ageSex"
                value={form.ageSex}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-6">
              <label>Ref. by Dr.:</label>
              <input
                type="text"
                className="form-control"
                name="doctor"
                value={form.doctor}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label>Date:</label>
              <input
                type="date"
                className="form-control"
                name="date"
                value={form.date}
                onChange={handleChange}
              />
            </div>
          </div>

          <h5>PHYSICAL EXAMINATION</h5>
          <div className="row mb-2">
            <div className="col-md-6">
              <label>Quantity (ml):</label>
              <input
                type="text"
                className="form-control"
                name="quantity"
                value={form.quantity}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label>Color:</label>
              <input
                type="text"
                className="form-control"
                name="color"
                value={form.color}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label>Appearance:</label>
              <input
                type="text"
                className="form-control"
                name="appearance"
                value={form.appearance}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label>pH:</label>
              <input
                type="text"
                className="form-control"
                name="ph"
                value={form.ph}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label>Specific Gravity:</label>
              <input
                type="text"
                className="form-control"
                name="specificGravity"
                value={form.specificGravity}
                onChange={handleChange}
              />
            </div>
          </div>

          <h5 className="mt-4">CHEMICAL EXAMINATION</h5>
          <div className="row">
            {[
              ["Glucose Sugar", "glucoseSugar"],
              ["Albumin Protein", "albuminProtein"],
              ["Ketone", "ketone"],
              ["Bile Salts", "bileSalts"],
              ["Bile Pigment", "bilePigment"],
              ["Urobilinogen", "urobilinogen"],
            ].map(([label, name]) => (
              <div className="col-md-6" key={name}>
                <label>{label}:</label>
                <input
                  type="text"
                  className="form-control"
                  name={name}
                  value={form[name]}
                  onChange={handleChange}
                />
              </div>
            ))}
          </div>
          <div className="row">
            <h5 className="mt-4">MICROSCOPIC EXAMINATION</h5>
            {[
              ["Leukocyte (pus cell) (/hpf)", "leukocyte"],
              ["Red Blood Cell", "redBloodCell"],
              ["Epithelial Cell (/hpf)", "epithelialCell"],
              ["Cast", "cast"],
              ["Bacteria", "bacteria"],
              ["Crystals", "crystals"],
            ].map(([label, name]) => (
              <div className="col-md-6" key={name}>
                <label>{label}:</label>
                <input
                  type="text"
                  className="form-control"
                  name={name}
                  value={form[name]}
                  onChange={handleChange}
                />
              </div>
            ))}
          </div>
          <button type="submit" className="btn btn-success mt-3">
            {editId ? "Update Report" : "Save Report"}
          </button>
          {editId && (
            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={() => {
                setEditId(null);
                setForm({
                  name: "",
                  ageSex: "",
                  doctor: "",
                  date: "",
                  quantity: "",
                  color: "",
                  appearance: "",
                  ph: "",
                  specificGravity: "",
                  glucoseSugar: "",
                  albuminProtein: "",
                  ketone: "",
                  bileSalts: "",
                  bilePigment: "",
                  urobilinogen: "",
                  leukocyte: "",
                  redBloodCell: "",
                  epithelialCell: "",
                  cast: "",
                  bacteria: "",
                  crystals: "",
                });
              }}
            >
              Cancel Edit
            </button>
          )}
        </form>

        {/* Table of reports */}
        <h4 className="mt-4">All Reports</h4>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>ID</th>
              <th>Pt. Name</th>
              <th>Age/Sex</th>
              <th>Doctor</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((r) => (
              <tr key={r.id}>
                <td>{r.id}</td>
                <td>{r.name}</td>
                <td>{r.ageSex}</td>
                <td>{r.doctor}</td>
                <td>{r.date}</td>
                <td>
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => handleEdit(r.id)}
                  >
                    ✏️
                  </button>
                  <button
                    className="btn btn-info btn-sm me-2"
                    onClick={() => handleView(r.id)}
                  >
                    👁️
                  </button>
                  <button
                    className="btn btn-danger btn-sm "
                    onClick={() => handleDelete(r.id)}
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Print view */}
      {/* Print & Close Buttons */}
      {selectedReport && (
        <>
          {/* Print Area */}
          <div
            className="print-area"
            style={{
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
              color: "#000",
              padding: "10mm",
            }}
          >
            {/* Title */}
            <div
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              URINE EXAMINATION REPORT
            </div>

            {/* Patient Info */}
            <table
              style={{
                width: "100%",
                marginBottom: "15px",
                border: "none",
                fontSize: "14px",
              }}
            >
              <tbody>
                <tr>
                  <td style={{ textAlign: "left", width: "50%" }}>
                    <strong>Pt. Name:</strong> {selectedReport.name}
                  </td>
                  <td style={{ textAlign: "right", width: "50%" }}>
                    <strong>Ref. by Dr.:</strong> {selectedReport.doctor}
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left" }}>
                    <strong>Age/Sex:</strong> {selectedReport.ageSex}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    <strong>Date:</strong> {selectedReport.date}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Investigation Title */}
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textDecoration: "underline",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              INVESTIGATION
            </div>

            {/* Investigation Table */}
            <table
              className="table table-bordered"
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr>
                  <th>Test</th>
                  <th>Result</th>
                  <th>Normal Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Quantity (ml)</td>
                  <td>{selectedReport.quantity}</td>
                  <td>..</td>
                </tr>
                <tr>
                  <td>Color</td>
                  <td>{selectedReport.color}</td>
                  <td>Pale yellow</td>
                </tr>
                <tr>
                  <td>Appearance</td>
                  <td>{selectedReport.appearance}</td>
                  <td>clear</td>
                </tr>
                <tr>
                  <td>pH</td>
                  <td>{selectedReport.ph}</td>
                  <td>6.0 to 8.0</td>
                </tr>
                <tr>
                  <td>Specific Gravity</td>
                  <td>{selectedReport.specificGravity}</td>
                  <td>1.003 to 1.035</td>
                </tr>
                <tr>
                  <td>Glucose Sugar</td>
                  <td>{selectedReport.glucoseSugar}</td>
                  <td>Nill</td>
                </tr>
                <tr>
                  <td>Albumin Protein</td>
                  <td>{selectedReport.albuminProtein}</td>
                  <td>Nill</td>
                </tr>
                <tr>
                  <td>Ketone</td>
                  <td>{selectedReport.ketone}</td>
                  <td>Nill</td>
                </tr>
                <tr>
                  <td>Bile Salts</td>
                  <td>{selectedReport.bileSalts}</td>
                  <td>Nill</td>
                </tr>
                <tr>
                  <td>Bile Pigment</td>
                  <td>{selectedReport.bilePigment}</td>
                  <td>Nill</td>
                </tr>
                <tr>
                  <td>Urobilinogen</td>
                  <td>{selectedReport.urobilinogen}</td>
                  <td>Normal</td>
                </tr>
                <tr>
                  <td>Leukocyte (pus cell) (/hpf)</td>
                  <td>{selectedReport.leukocyte}</td>
                  <td>2-3 /hpf</td>
                </tr>
                <tr>
                  <td>Red Blood Cell</td>
                  <td>{selectedReport.redBloodCell}</td>
                  <td>Nill</td>
                </tr>
                <tr>
                  <td>Epithelial Cell (/hpf)</td>
                  <td>{selectedReport.epithelialCell}</td>
                  <td>2-3 /hpf</td>
                </tr>
                <tr>
                  <td>Cast</td>
                  <td>{selectedReport.cast}</td>
                  <td>Nill</td>
                </tr>
                <tr>
                  <td>Bacteria</td>
                  <td>{selectedReport.bacteria}</td>
                  <td>Nill</td>
                </tr>
                <tr>
                  <td>Crystals</td>
                  <td>{selectedReport.crystals}</td>
                  <td>Nill</td>
                </tr>
              </tbody>
            </table>

            {/* Footer */}
            <p className="text-center mt-4">
              <strong>*****END OF REPORT*****</strong> &nbsp;&nbsp;&nbsp;&nbsp;
              Technologist
            </p>
          </div>
          <button
            className="no-print btn btn-primary my-3 me-3"
            onClick={() => window.print()}
          >
            🖨️ Print Report
          </button>
        </>
      )}
    </>
  );
}

export default UrineForm;
